module.exports = __webpack_public_path__ + "img/beautify9.fef4aa80.webp";